import { render, staticRenderFns } from "./PublishInfo.vue?vue&type=template&id=0dec7275"
import script from "./PublishInfo.vue?vue&type=script&lang=js"
export * from "./PublishInfo.vue?vue&type=script&lang=js"
import style0 from "./PublishInfo.vue?vue&type=style&index=0&id=0dec7275&prod&lang=css"
import style1 from "./PublishInfo.vue?vue&type=style&index=1&id=0dec7275&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports